import { HttpClient } from '@angular/common/http';
import { Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { SseService } from 'src/app/services/SseService';

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrl: './noticias.component.scss'
})
export class NoticiasComponent implements OnChanges {
  @Input() compania: string = '';
  panelOpenState = false;
  public noticias: any;
  constructor(private _sseService: SseService){

  }
  ngOnChanges(changes: SimpleChanges){

    let url='v3/press-releases/'+changes['compania'].currentValue;
    this._sseService.apiGetNew(url).subscribe({
      next: (data: any)=>{
        this.noticias = data;
      }
    });
  }
}
